(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accelerated-checkout"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    // Fix "More payment options" link behavior
    const morePaymentOptionsLink = document.querySelector('.shopify-payment-button__more-options');
    if (morePaymentOptionsLink) {
      morePaymentOptionsLink.addEventListener('click', function(e) {
        // Only prevent default if href is "#"
        if (this.getAttribute('href') === '#') {
          e.preventDefault();
          e.stopPropagation();

          // Find all payment buttons in the container
          const container = this.closest('.shopify-payment-button');
          if (container) {
            const allButtons = container.querySelectorAll('.shopify-payment-button__button');
            // Show all hidden payment buttons
            allButtons.forEach(function(btn) {
              if (btn.style.display === 'none' || btn.hasAttribute('hidden')) {
                btn.style.display = '';
                btn.removeAttribute('hidden');
              }
            });
            // Hide the "more options" link after clicking
            this.style.display = 'none';
          }
        }
      }, true); // Use capture phase to ensure this runs first
    }
  });
  } catch(e) { console.error(e); }
})();

})();
